import { StyleShadowRoot } from "@redotech/react-util/style";
import { HsaPdpWidgetPlacement } from "@redotech/redo-conversion-core-common/conversion/hsa-autocheck";
import { ModalRootContext } from "@redotech/redo-web/modal-root";
import { memo } from "react";
import { StorefrontClient } from "../../client/storefront";
import STYLE_MANAGER from "../../style-manager";
import { HsaPdpBadge } from "./hsa-pdp-badge";
import { useHsaPdpPortals } from "./use-hsa-pdp-portals";
import { useHsaVariantEligibility } from "./use-hsa-variant-eligibility";

export const HsaPdpInitializer = memo(function HsaPdpInitializer({
  placement,
  storefrontClient,
}: {
  placement: HsaPdpWidgetPlacement;
  storefrontClient: StorefrontClient;
}) {
  const eligibility = useHsaVariantEligibility({ storefrontClient });
  const portals = useHsaPdpPortals({ placement });

  if (portals.length === 0 || eligibility === undefined) {
    return null;
  }

  return (
    <>
      {portals.map(({ portal }, index) => (
        <StyleShadowRoot
          key={index}
          shadowRoot={portal.root}
          styleManager={STYLE_MANAGER}
        >
          <ModalRootContext.Provider value={portal.modalContainer}>
            <HsaPdpBadge eligibility={eligibility} />
          </ModalRootContext.Provider>
        </StyleShadowRoot>
      ))}
    </>
  );
});
